import {useQuery} from '@tanstack/react-query';
import {
  getConceptExplorerData,
  postConceptDocList,
  postGenerateClusterSummaryReport,
  postSaveSearchConceptReport
} from '../../api/endpoints/conceptExplorerApi';
import {
  IConceptExplorer,
  IConceptDocListRequest,
} from '../../api/types/conceptExplorer.type';
import {useMutation} from '@tanstack/react-query';
import {
  postConceptReport,
  ConceptExploreView,
} from '../../api/endpoints/conceptExplorerApi';

export const useConceptExplorer = (payload: IConceptExplorer) => {
  return useQuery<any, Error, any>({
    queryKey: ['GetConceptExplorerData', payload],
    queryFn: () => getConceptExplorerData(payload),
    retry: 0,
    enabled: !!payload.ReportId,
  });
};
export const useGetExplorer = () => {
  return useMutation({
    mutationFn: (payload: any) => ConceptExploreView(payload),
  });
};

export const useSaveConceptMapReportData = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) =>
  useMutation<any, Error, any>({
    mutationFn: postConceptReport,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export const useSaveSearchCriteria = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) =>
  useMutation<any, Error, any>({
    mutationFn: postSaveSearchConceptReport,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export const useGenerateClusterSummaryReport = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) =>
  useMutation<any, Error, any>({
    mutationFn: postGenerateClusterSummaryReport,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export const useConceptDocList = (
  onSuccess?: (data: number) => void,
  onError?: (err: Error) => void
) =>
  useMutation<number, Error, IConceptDocListRequest>({
    mutationFn: postConceptDocList,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
